import './App.svelte.css';
/* src/App.svelte generated by Svelte v3.38.2 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	handle_promise,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	text,
	transition_in,
	transition_out,
	update_await_block_branch
} from "../_snowpack/pkg/svelte/internal.js";

import Cards from "./components/Cards.svelte.js";
import { fetchSchema } from "./lib/fetch-schema.js";
import { getFetchOptions } from "./lib/get-fetch-options.js";

function create_catch_block(ctx) {
	let p;
	let t0;
	let t1_value = /*error*/ ctx[4].message + "";
	let t1;

	return {
		c() {
			p = element("p");
			t0 = text("Something went wrong: ");
			t1 = text(t1_value);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			append(p, t1);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (14:2) {:then schemas}
function create_then_block(ctx) {
	let cards;
	let current;
	cards = new Cards({ props: { schemas: /*schemas*/ ctx[3] } });

	return {
		c() {
			create_component(cards.$$.fragment);
		},
		m(target, anchor) {
			mount_component(cards, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(cards.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(cards.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(cards, detaching);
		}
	};
}

// (12:25)      <p>Loading schemas...</p>   {:then schemas}
function create_pending_block(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = "Loading schemas...";
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let promise;
	let current;

	let info = {
		ctx,
		current: null,
		token: null,
		hasCatch: true,
		pending: create_pending_block,
		then: create_then_block,
		catch: create_catch_block,
		value: 3,
		error: 4,
		blocks: [,,,]
	};

	handle_promise(promise = /*fetchSchemas*/ ctx[0](), info);

	return {
		c() {
			div = element("div");
			info.block.c();
			attr(div, "class", "svelte-163tlnw");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			info.block.m(div, info.anchor = null);
			info.mount = () => div;
			info.anchor = null;
			current = true;
		},
		p(new_ctx, [dirty]) {
			ctx = new_ctx;
			update_await_block_branch(info, ctx, dirty);
		},
		i(local) {
			if (current) return;
			transition_in(info.block);
			current = true;
		},
		o(local) {
			for (let i = 0; i < 3; i += 1) {
				const block = info.blocks[i];
				transition_out(block);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			info.block.d();
			info.token = null;
			info = null;
		}
	};
}

function instance($$self) {
	const [optionsA, optionsB] = getFetchOptions();

	const fetchSchemas = () => {
		return Promise.all([fetchSchema(optionsA), fetchSchema(optionsB)]);
	};

	return [fetchSchemas];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;